import { trendingItem } from "../fragments/contentItem";

const allContentItemsQuery = `query trending($lineupSlug: String, $categorySlug: String, $pageSize: Int) {
    allContentItems(lineupSlug: $lineupSlug, categorySlug: $categorySlug, pageSize: $pageSize, targets: [WEB,ALL]) {
        nodes {
            ...trendingItem
        }
    }
}
${trendingItem}`;

export default allContentItemsQuery;
